// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"205":"c01358e6","234":"3ab5654b","254":"7fa20d3d","440":"25cd0b9e","445":"ec192d9e","633":"24147e7c","674":"c1f3bc70","680":"37a029bc","710":"46bd3a79","727":"da3d9e3d","738":"f8f2170a","973":"ff8dc4b6"}[chunkId] + ".js";
};